<template>
  <div>
    <div>
      <Titulo :titulo="'Informes - '+routeName" />
    </div>
    <!-- coger el parametro que se envio por la ruta -->
    <!-- {{$route.params.id}} -->
    <div class="margin-informes">
      <br />
      <!--
        @props
            data: Array,            required: true
            pagination: boolean,    required: false
            perPage: Number,        required: false
            SetectFiltro: Array     required: false
            filtro: boolean         required: false
      -->
      <table-component
        :data="data"
        @click-buscar="buscar"
        @click-event="clickEvent"
        pagination
        filtro
        showExportToExcel
        showFilterCedula
        :perPage="perPage"
        :dataLength="dataLength"
      >
        <table-column slot="label" :label="'Modelo'" v-bind:value="'modelo'"></table-column>
        <table-column slot="label" :label="'Nombre'" v-bind:value="'nombre'"></table-column>
        <table-column slot="label" :label="'Cédula'" v-bind:value="'cedula'"></table-column>
        <table-column slot="label" :label="'Pagaré'" v-bind:value="'pagare'"></table-column>
        <table-column
          slot="label"
          :label="'Valor'"
          v-bind:value="'valor'"
          :filter="'numberFormat'"
          :customClass="'text-right'"
        ></table-column>
        <table-column slot="label" :label="'Fecha Aplicación'" v-bind:value="'fecha_aplicacion'"></table-column>
        <table-column slot="label" :label="'Estado'" v-bind:value="'estado'"></table-column>
      </table-component>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SelectNovedad from "@/data/SelectQueEsNovedad.json";
import SelectTipoNovedad from "@/data/SelectTipoNovedad.json";

import XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "SubirInformes",
  data() {
    return {
      cedula: null,
      perPage: 10,
      informe_url: "informes/reintegro",
      filename: "Reintegros ",
    };
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  computed: {
    ...mapGetters({
      TablaVerProducto: "pages/TablaVerProducto",
      SelectFiltroTabla: "pages/SelectFiltroTabla",
      loading: "loading",
    }),
    dataLength() {
      return this.$store.getters["pages/dataInformes"].paginacion.total;
    },
    data() {
      return this.$store.getters["pages/dataInformes"].datos;
    },
    routeName() {
      return this.$router.currentRoute.name;
    },
  },
  methods: {
    buscar(event) {
      this.cedula = event.cedula;
      this.loadData();
    },
    async clickEvent(data, slug) {
      switch (slug) {
        case "paginacion":
          this.loadData(data.nRows, data.page);
          break;
        case "export-to-excel":
          this.$toasted.show("Por favor espere mientras exportamos los datos", {
            theme: "toasted-primary",
            position: "top-center",
            duration: 5000,
          });
          this.$store.commit("SET_LOADING", true);
          try {
            let result = await this.$store.state.api.get(this.informe_url, {
              params: {
                paginar: false,
                cedula: this.cedula,
              },
            });

            let data = XLSX.utils.json_to_sheet(result.data.datos, {
              header: [
                "modelo",
                "nit",
                "nombre",
                "cedula",
                "pagare",
                "valor",
                "fecha_aplicacion",
                "estado",
              ],
            });

            data["A1"].v = "Modelo";
            data["B1"].v = "Nit";
            data["C1"].v = "Nombre";
            data["D1"].v = "Cédula";
            data["E1"].v = "Pagaré";
            data["F1"].v = "Valor";
            data["G1"].v = "Fecha Aplicación";
            data["H1"].v = "Estado";

            var workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, data, this.fileName);
            var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
            var wbout = XLSX.write(workbook, wopts);
            var today = new Date();
            var dd = today.getDate();

            var mm = today.getMonth() + 1;
            var yyyy = today.getFullYear();

            if (dd < 10) {
              dd = "0" + dd;
            }

            if (mm < 10) {
              mm = "0" + mm;
            }

            today = dd + "/" + mm + "/" + yyyy;
            saveAs(
              new Blob([wbout], { type: "application/octet-stream" }),
              this.filename + today + ".xlsx"
            );
            this.$toasted.show("El archivo fue exportado exitosamente", {
              theme: "toasted-primary",
              position: "top-right",
              duration: 10000,
            });
          } catch (err) {
            this.$toasted.show(
              "Ocurrió un error al intentar exportar el archivo",
              {
                theme: "toasted-primary",
                position: "top-right",
                duration: 10000,
              }
            );
          }
          this.$store.commit("SET_LOADING", false);
          break;
        default:
          break;
      }
    },
    loadData(row, page, paginar = true) {
      this.$store.dispatch("pages/fetch", {
        endpoint: this.informe_url,
        params: {
          row: this.perPage,
          page: page ? page : 1,
          paginar: paginar,
          cedula: this.cedula,
        },
      });
    },
  },
  mounted() {
    this.loadData(this.perPage, 1);
  },
};
</script>